import MpdTooltip from './MpdTooltip.vue'

export default MpdTooltip
